
export const formatDateToBR = (dateString) => {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-");
  return `${day}/${month}/${year}`;
};

export const formatDateTimeToBR = (dateTimeString) => {
  if (!dateTimeString) return "";

  const dateObj = new Date(dateTimeString);

  if (isNaN(dateObj.getTime())) {
    return "";
  }

  // Formata dia, mês e ano com 2 dígitos
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();

  // Formata hora e minuto com 2 dígitos
  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};


export const formatDateTimeToISO = (dateTimeString) => {
  if (!dateTimeString) return "";

  const dateObj = new Date(dateTimeString);
  if (isNaN(dateObj.getTime())) {
    return "";
  }

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  const seconds = String(dateObj.getSeconds()).padStart(2, "0");

  // Formato ISO simplificado (sem fuso horário)
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

// desabilita sábados (6) e domingos (0)
export const disableWeekends = (current) => {
  const day = current.day();
  return day === 0 || day === 6;
};
